import React from 'react'
import { useHideNavigation } from '../../../context'
import CulminatingMomentScreen from './CulminatingMomentScreen'
import DeathScreen from './DeathScreen'
import ImageScreen from './ImageScreen'
import MapScreen from './MapScreen'
import NavigationScreen from './NavigationScreen'
import PauseScreen from './PauseScreen'
import QuestionSlotScreen from './QuestionSlotScreen'
import VideoScreen from './VideoScreen'

import type { Screen as ScreenType } from '@mission.io/mission-toolkit'
import { CollaborativeCulminatingMomentScreen } from './CollaborativeCulminatingMomentScreen/CollaborativeCulminatingMomentScreen'

/**
 *  A default switch that will return the correct screen component according to the screen
 * state value passed in
 * @param {Screen} props.screen a screen to display
 * @param {boolean} props.showASLVideo whether or not the asl video should be displayed
 */
export default function Screen({
	showASLVideo,
	screen,
}: {
	showASLVideo: boolean,
	screen: ScreenType,
}): React$Node {
	const hideNavigation = useHideNavigation()
	if (screen.type === 'VIDEO') {
		return <VideoScreen showASLVideo={showASLVideo} screen={screen} />
	} else if (screen.type === 'IMAGE') {
		return <ImageScreen />
	} else if (screen.type === 'NAVIGATION') {
		return <NavigationScreen teacherView={hideNavigation} />
	} else if (screen.type === 'MAP') {
		return <MapScreen />
	} else if (screen.type === 'CULMINATING_MOMENT') {
		return <CulminatingMomentScreen />
	} else if (screen.type === 'QUESTION_SLOT') {
		return <QuestionSlotScreen />
	} else if (screen.type === 'COLLABORATIVE_CULMINATING_MOMENT_SCREEN') {
		return <CollaborativeCulminatingMomentScreen screen={screen} />
	} else {
		return null
	}
}

export { DeathScreen, PauseScreen }
